export default __webpack_public_path__ + "static/media/Cart.11a6a373.svg";